import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import routes from './routes';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresOTP)) {
    if (store.getters.isAuthenticated && store.getters.isOTPVerified) {
      next();
      return;
    } else if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/otpverification');
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.verifyUsername)) {
    if (store.getters.isAuthenticated && store.getters.isUsernameVerified) {
      next();
      return;
    } else if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/username');
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.verifyEmail)) {
    if (store.getters.isAuthenticated && store.getters.isEmailVerified) {
      next();
      return;
    } else if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/verifyemail');
  } else {
    next();
  }
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js